import React from 'react';
import './ss-loader.css';

const SSLoader = ({ loading }) => {
    if (!loading) return null;

    return (
        <div className="ss-loader-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" width="auto" height="200" viewBox="0 0 246.8 152.9">
                <defs>
                    <style>
                        {`.cls-logo {
                            fill: none;
                        stroke: #fff;
                        stroke-miterlimit: 10;
                        stroke: 2px
                        }`}
                    </style>
                </defs>
                <g>
                    <polygon className="cls-logo" points="238.3 56.2 184.3 56.2 167.7 4.9 150.9 56.2 96.9 56.2 89.7 56.2 89.1 58.5 87.3 56.2 74.1 56.2 67.8 60.8 63.7 56.2 44.3 56.2 43.4 59.3 40.9 56.2 28.5 56.2 19.4 63 15.5 77.9 18.7 81.8 14.4 81.8 13.7 84.8 11.3 93.7 18.1 102.2 31.2 102.2 32.4 101.3 32.3 102.2 37.5 102.2 48.6 102.2 52.1 89.5 56.4 89.5 58.1 88.3 56.7 93.7 58.1 95.4 63.5 102.2 76.7 102.2 77.8 101.3 77.6 102.2 82.9 102.2 90.6 102.2 105.3 102.2 107.1 102.2 110.5 102.2 121.7 102.2 123.7 94.9 129.4 102 135.9 102 123.8 139.2 167.7 107.5 211.4 139.2 194.6 88 238.3 56.2" />
                    <polygon className="cls-logo" points="35.1 75.6 28.3 75 30.3 67.4 35.6 67.4 34.2 72.6 41.3 72.6 43.1 65.5 38.9 60.3 29.8 60.3 23 65.5 20 76.9 24.6 82.4 31.4 83 29.4 90.8 24.2 90.8 25.5 85.9 17.6 85.9 15.8 92.8 20 98 29.8 98 36.8 92.8 39.8 81.2 35.1 75.6" />
                    <path className="cls-logo" d="M61.7,60.3h-14.4l-10,37.6h7.9l3.3-12.7h6.3l7.4-5.3,3.8-14.5-4.7-5.1h.3ZM55.2,78.2h-4.5l2.9-10.6h4.5l-2.9,10.6h0Z" />
                    <path className="cls-logo" d="M85.3,60.3h-9.8l-7,5.1-7.3,27.2,4.2,5.1h9.8l7-5.1,7.3-27.2-4.2-5.1ZM81.1,67.4l-6.2,23.3h-5.1l6.2-23.3s5.1,0,5.1,0Z" />
                    <path className="cls-logo" d="M111.9,65.3l-4.1-5h-15l-10,37.6h7.9l4.1-15.4h5.1l-4.1,15.4h7.9l4.1-15.4-3.8-3.6,5.1-3.8,2.6-9.8h.2ZM101.9,75.6h-5.1l2.1-8h5.1l-2.1,8Z" />
                    <polygon className="cls-logo" points="134 60.3 114.9 60.3 113.1 67.4 118.7 67.4 110.5 98 118.6 98 126.6 67.4 132.2 67.4 134 60.3" />
                    <polygon className="cls-logo" points="151.4 81.2 146.7 75.6 139.9 75 141.8 67.4 147 67.4 145.6 72.6 152.9 72.6 154.7 65.5 150.5 60.3 141.4 60.3 134.4 65.5 131.6 76.9 136.1 82.4 142.9 83 140.8 90.8 135.6 90.8 137 85.9 129.1 85.9 127.3 92.8 131.4 98 141.4 98 148.2 92.8 151.4 81.2" />
                </g>
            </svg>
        </div>
    );
};

export default SSLoader;
